Namespace 'Monitoring.Views.Dashboards'

class Monitoring.Views.Dashboards.TagsHierarchySearchBoxView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents/tags_editor/tags_hierarchy_search_box']
  className: 'navigation-tag position-relative'
  searchDelay: 1000

  events:
    'keyup #search-tag-box': 'onEnterText'

  render: ->
    @$el.html @template
    setTimeout @_focusOnSearchBox, 500
    @

  _focusOnSearchBox: =>
    @$('#search-tag-box').focus()

  onEnterText: ->
    clearTimeout @searchTimer
    @searchTimer = setTimeout @search, @searchDelay

  search: =>
    @trigger 'search-box:search', value: @$('#search-tag-box').val()
